module.exports = __webpack_public_path__ + "static/media/home_brand_library_btn.e09c5f32.png";